import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material/styles';

export const footerNavbarSX: SxProps<Theme> = {
	backgroundColor:'navbar.primary',
    height:globalBreak({mobile:'auto',desktop:100}),
    color: '#000'
};


const footerMenuStyles:SxProps = {
	listStyle:'none',
	color: '#000',
	display:'grid',
	gridTemplateColumns:globalBreak({mobile:'1fr', desktop:'3fr 3fr 3fr 3fr 5fr'}),
	py:3,
	px:0,
	'& a':{
		color: '#000',
		textDecoration:'none'
	},
	'&  li > ul':{
		mb:globalBreak({mobile:2,desktop:0})
	},
	'& ul , & li':{
		listStyle:'none',
		p:0,
	},
	'& a:hover':{
		textDecoration:'underline'
	},
	'& .footer-links-header':{
		fontFamily:globalBreak({mobile:'mikado-bold', desktop:'chaloops-bold'}),
		mb:1.5,
		pb:0.5,
		borderBottom:globalBreak({mobile:'2px solid', desktop:'none'}),
		display:'block',
	},
	'& .footer-links-header::after':{
		content: '""',
		display: 'inline-block',
		width: '20px',
		height: '20px',
		backgroundImage: 'url("https://image.intertoys.nl/wcsstore/IntertoysSAS/images/colors/color1/angle-down-solid-black.png")',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		marginLeft: '6px',
		verticalAlign: 'middle',
		float:'right',
		mt:1
	},
	'& .footer-links-header.selected::after':{
		transform: 'rotateZ(180deg)',
		position:'relative',
		bottom:12
	}
}

const footerNewsLetterStyles:SxProps = {
	bgcolor:globalBreak({mobile:'inherit', desktop:'#fff'}),
	width:'100%',
	height:'100%',
	borderRadius:0.5,
	'& .footer-news-letter-container':{
		px:globalBreak({mobile:0, desktop:5.5}),
		py:globalBreak({mobile:0, desktop:2}),
		position:'relative',
		'& > img':{
			height:'3em',
			position:'absolute',
			display:globalBreak({mobile:'none', desktop:'block'}),
		},
		'& .footer-newsletter-image-1':{
			top:'-2.5em'
		},
		'& .footer-newsletter-image-2':{
			top:0,
			right:'16%'
		},
		'& .news-letter-ui-content':{
			display:'flex',
			mt:globalBreak({mobile:3, desktop:1}),
			flexDirection:'column',
			rowGap:2,
			'& .title':{
				'& label':{
					m:0,
					width:'55%',
					fontFamily:'chaloops-bold',
					fontWeight:'400',
					fontSize:globalBreak({mobile:18, desktop:16}),
					display:'block'
				}
			},
			'& .user-email-text-box':{
				width:globalBreak({mobile:'65%', desktop:'100%'}),

				'& input':{
					p:1,
					borderRadius:0.5,
					width:'100%',
					border:'1px solid #c4c4c3',
					fontSize:'16px'
				},
                '& input.error':{
                    borderColor:'red'
                },
				'& input::placeholder':{
					color:'#545454',
					fontSize:'16px'
				}
			},
			'& .news-letter-submit':{
				display:'flex',
				flexDirection:globalBreak({mobile:'row', desktop:'column'}),
				rowGap:2.5,
				columnGap:2,
                alignItems: globalBreak({mobile:'center', desktop:'flex-start'}),
				'& .news-letter-submit-btn':{
					p:globalBreak({mobile:'2px',desktop:1}),
					width:'8em',
					display:'flex',
					alignItems:'center',
					justifyContent:'center',
					columnGap:1,
					border:'none',
					outline:'none',
					bgcolor:'#ff6500',
					borderRadius:0.5,
					'& > div':{
						display:'flex',
						columnGap:0.5,
						cursor:'pointer',
						fontFamily:'mikado-bold',
						fontWeight:400
					}
				}
			}
		}
	}
}

const footerVolgOnStyles:SxProps = {
	mt:globalBreak({mobile:2, desktop:0}),
	display:'flex',
	flexDirection:globalBreak({mobile:'column', desktop:'row'}),
	justifyContent:'center',
	alignItems:'center',
	rowGap:1,
	columnGap:2,
	'& .footer-payment-methods-header':{
		fontFamily:'chaloops-bold',
		fontSize:globalBreak({mobile:18, desktop:16})
	},
	'& .footer-social-icons-list':{
		display:'flex',
		columnGap:0.5
	}
}

export const footerLinksContainerSX: SxProps<Theme> = {

    '& #footerMenu': footerMenuStyles,
	'& .footer-news-letter': footerNewsLetterStyles,
	'& .footer-volg-on': footerVolgOnStyles,
};

export const footerHippoImage:  SxProps<Theme> = { 
   '&#checkout_footerHippoImage' :{
		height:globalBreak({mobile:150, desktop:'auto'}),
		position: 'absolute',
		zIndex:1,
		bottom: globalBreak({mobile:'unset', desktop:'6em'}),
		top: globalBreak({mobile:'1em', desktop:'unset'}),
   }  

   //Mobile 
  /*  max-height: 150px;
    bottom: -16em; */
};